export default __webpack_public_path__ + "static/media/toggle-edges.b419d928.svg";